export const IPE_SAUDE_X_LINK = 'https://x.com/ipesauders';
export const IPE_SAUDE_FLICKR_LINK = 'https://www.flickr.com/photos/ipesaude';
export const IPE_SAUDE_INSTAGRAM_LINK = 'https://www.instagram.com/ipesauders/';
export const IPE_SAUDE_YOUTUBE_LINK = 'https://www.youtube.com/channel/UC8p2wudtXDhCpASW6Gr6b2g';
